import {
	type ReactNode,
	type HTMLAttributes,
	type ReactElement,
	type CSSProperties,
} from 'react';
import styles from './content-split.module.scss';

const ContentSplit = (props: IProps) => {
	const {
		aside,
		children,
		main,
		gap = 'var(--spacing-m)',
		withVerticalCenter = false,
		inverted = false,
		invertMobileOnly = false,
	} = props;

	let classString = styles.contentSplit;

	// inverted always overrides invertMobileOnly
	if (inverted) {
		classString = `${classString} ${styles.inverted}`;
	} else if (invertMobileOnly) {
		classString = `${classString} ${styles.invertMobileOnly}`;
	}

	//TODO: handle this in the CSS so we dont need to account for it here.
	classString =
		aside || children?.[1]
			? classString
			: `${classString} ${styles.emptyAside}`;

	//TODO: remove the one off need for this.
	classString = withVerticalCenter
		? `${classString} ${styles.withVerticalCenter}`
		: classString;

	//TODO: remove the one off need for this.
	classString = withVerticalCenter
		? `${classString} ${styles.withVerticalCenter}`
		: classString;

	return (
		<section
			className={classString}
			style={{ '--content-split-gap': gap } as CSSProperties}
		>
			<div className={styles.main}>{main || children?.[0]}</div>
			<aside className={styles.aside}>{aside || children?.[1]}</aside>
		</section>
	);
};

interface IProps extends HTMLAttributes<HTMLElement> {
	aside?: ReactNode;
	children?: [ReactNode, ReactNode] | ReactElement; //One single element or an array of 2 nodes.
	main?: ReactNode;
	gap?: string;
	/**
	 * @deprecated Wrap ContentSplit in a PageSection or SubSection and use that title property.
	 */
	title?: never;
	/**
	 * @deprecated This is weird and should be removed.
	 */
	withVerticalCenter?: boolean;
	/**
	 * @deprecated Wrap ContentSplit in a PageSection or SubSection and use that divider property.
	 */
	withDivider?: never;
	/**
	 * @deprecated Don't do this, if the design requires you to do this talk to Joseph or Julie
	 */
	className?: never;
	inverted?: boolean;
	invertMobileOnly?: boolean;
}

export default ContentSplit;
